import React from 'react';
import AuthenticationLayout from '../../layouts/authenticationLayout';
import ForgotPasswordForm from './components/forgotPasswordForm';

const ForgotPassword = () => {
  return (
    <AuthenticationLayout
      title="Forgot Password"
      subtitle="Reset your account password securely"
    >
      <ForgotPasswordForm />
    </AuthenticationLayout>
  );
};

export default ForgotPassword;